/**
 * PremiumCTABanner — CUADRO NEGRO Premium CTA Visual (feb-2026)
 *
 * Banner sutil que aparece arriba del Workspace cuando el ORB detecta que el
 * usuario ya está enganchado (free + first_action_at + free_used >= 10).
 * El control de visibilidad real vive en `usePremiumCTA`; este componente
 * sólo se monta cuando el padre decide mostrarlo.
 *
 * Comportamiento:
 *  - Click "Ver planes" → navigateToPremium (scrolls a la sección de planes
 *    o navega a /planes-y-beneficios). Misma UX que el resto de los CTAs.
 *  - Click ✕ → onClose() (el padre persiste el cierre en sessionStorage).
 *  - Sin popups, sin bloqueos, sin interrupciones.
 */
import './PremiumCTABanner.css';
import { X } from 'lucide-react';
import { navigateToPremium } from '../utils/navigateToPremium';
import { useLanguage } from '../context/LanguageContext';

export default function PremiumCTABanner({ onClose }) {
  const { language } = useLanguage();
  const isEs = language === 'es';

  return (
    <div
      className="premium-cta-banner"
      role="region"
      aria-label={isEs ? 'Sugerencia Premium' : 'Premium suggestion'}
      data-testid="premium-cta-banner"
    >
      <div className="premium-cta-text">
        <span aria-hidden="true">🎁</span>{' '}
        {isEs
          ? 'Estás aprovechando DamyxIA al máximo.'
          : 'You are getting the most out of DamyxIA.'}
        <span className="premium-cta-highlight">
          {isEs
            ? 'Sumá Premium y obtené imágenes ilimitadas.'
            : 'Go Premium and get unlimited images.'}
        </span>
      </div>

      <div className="premium-cta-actions">
        <button
          type="button"
          className="premium-cta-button"
          onClick={navigateToPremium}
          data-testid="premium-cta-button"
        >
          {isEs ? 'Ver planes' : 'See plans'}
        </button>

        <button
          type="button"
          className="premium-cta-close"
          onClick={onClose}
          aria-label={isEs ? 'Cerrar' : 'Close'}
          data-testid="premium-cta-close"
        >
          <X className="w-4 h-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
